import React, { FC } from 'react';
import { Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useGetClientBillingReportAggregateQuery } from 'api';
import { Loaders } from 'components';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles(() => ({
  infoIcon: {
    height: '14px',
    marginLeft: '2px',
  },
}));

const ClientBillingReportRow: FC = () => {
  const { t } = useTranslation();
  const { isLoading, data } = useGetClientBillingReportAggregateQuery();
  const classes = useStyles();

  if (isLoading) {
    return (
      <Grid container item justify="center">
        <Loaders.Standard height={42} />
      </Grid>
    );
  }

  const results = data.getClientBillingReportAggregate;
  if (!results?.contract_committed_user_count) {
    // If there is no committed user count, then there is no concept of overage.
    return null;
  }

  return (
    <Grid container item spacing={3}>
      <Grid item xs={4}>
        <Tooltip arrow title={t('admin:committedUsersDescription')} placement="top">
          <Typography variant="overline" color="textSecondary">
            {t('admin:committedUsers')}
            <InfoOutlinedIcon className={classes.infoIcon} />
          </Typography>
        </Tooltip>
        <Typography noWrap variant="subtitle2">
          {results.contract_committed_user_count}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Tooltip arrow title={t('admin:activeUsersDescription')} placement="top">
          <Typography variant="overline" color="textSecondary">
            {t('admin:activeUsers')}
            <InfoOutlinedIcon className={classes.infoIcon} />
          </Typography>
        </Tooltip>
        <Typography noWrap variant="subtitle2">
          {results.total_users}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Tooltip arrow title={t('admin:flexUsersDescription')} placement="top">
          <Typography variant="overline" color="textSecondary">
            {t('admin:flexUsers')}
            <InfoOutlinedIcon className={classes.infoIcon} />
          </Typography>
        </Tooltip>
        <Typography noWrap variant="subtitle2">
          {results.user_overage}
        </Typography>
      </Grid>
    </Grid>
  );
};
export default ClientBillingReportRow;
